import axios from "axios";
import request from "superagent";
export var role_name = "";
export var role_send_data = "";
export var all = [];
export var arr = [];
export var perm_act_opt = [];

export var perm_data = async () => {
  
  if (arr.length === 0) {
    await axios
      .get(`/api/v1/auth/roles`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "JWT " + localStorage["token"],
        },
      })
      .then((x) => {
        all = x.data.data.role_all;
        arr = x.data.data.new_role;
        role_name = x.data.data.role_name;
        role_send_data = x.data.data.role_send_data;
        perm_act_opt = x.data.data.perm_act_opt;
        //console.log(`arr = ${JSON.stringify(arr)}`)
        // console.log(`role_name = ${JSON.stringify(role_name)}`)
        // console.log(`role_send_data = ${JSON.stringify(role_send_data)}`)
        //console.log(`perm_act_opt = ${JSON.stringify(perm_act_opt)}`)
      })
      .catch((x) => {
        console.log("authen error");
      });
  }
};

export var perm = (id, type) => {
  var check = arr.findIndex(
    (i) => _.toNumber(i.perm_item_id) === _.toNumber(id) && _.toNumber(i.perm_action_type_id) === _.toNumber(type)
  );
  
  if (check >= 0) {
    return true;
  } else {
    return false;
  }
};

global.prswperm = async(id, type) => {
  
  if(arr.length == 0) await perm_data()
  var check = arr.findIndex(
    (i) => _.toNumber(i.perm_item_id) === _.toNumber(id) && _.toNumber(i.perm_action_type_id) === _.toNumber(type)
  );
 
  if (check >= 0) {
    return true;
  } else {
    return false;
  }
};


export var perm_t = (id) => {
  var check = arr.findIndex(
    (i) => i.topic_id === id && i.perm_action_type_id === 1
  );

  if (check >= 0) {
    return true;
  } else {
    return false;
  }
};


export var perm_s = (id) => {
  var check = arr.findIndex(
    (i) => i.sub_topic_id === id && i.perm_action_type_id === 1
  );

  if (check >= 0) {
    return true;
  } else {
    return false;
  }
};


//======= For TOA Only =========
export var admin_user_is_view_by_level = (item_id,sub_item_id,act_type)=>{
  //console.log(`perm_act_opt = ${JSON.stringify(perm_act_opt)}`)
  if(perm(sub_item_id,act_type)==false)
    return false

  const tmp = perm_act_opt
  const rs = tmp.filter(it=>{
    if(it.item_id == item_id && it.sub_item_id == sub_item_id && 
      it.act_type == act_type){
      return it
    }
  })

  if(rs.length==0) // ไม่ได้กำหนดสิทธิ์การมองเห็นให้กับกรณีของ Level ดังนั้นให้แสดงทุก Level เลย
  {
    return "all"
  }
  else{
    if(rs[0].act_type_desc)
    {
      //console.log(`rs[0].act_type_desc = ${rs[0].act_type_desc}`)
      return rs[0].act_type_desc // ให้ทำการตรวจสอบต่อไปว่า level ที่กำหนดไว้มีอะไรบ้าง (expat,M1,M2,...)
    }
    else{
      return "all" // act_type_desc ไม่มีค่า ดังนั้นให้แสดงทุก Level เลย
    }
  }
}

export var perm_is_exp = (item_id,sub_item_id,act_type) => {
  // 09 is code of expat

  if(perm(sub_item_id,act_type)==false)
    return false

  const tmp = perm_act_opt
  const rs = tmp.filter(it=>{
    if(it.item_id == item_id && it.sub_item_id == sub_item_id && 
      it.act_type == act_type && (it.act_type_desc.indexOf('09') || it.act_type_desc.indexOf('99')) > -1){
      return it
    }
  })
  return rs.length>0 ? true : false

}

export var emp_is_expat = (id_card) => {
  //console.log(`id_card = ${id_card}`)
  const p = id_card && (id_card.substring(0,2)=="09" || id_card.substring(0,2)=="99") ? true : false
  return p
}

export var is_admin_emp_have_perm = (item_id,sub_item_id,act_type,id_card,emp_level)=>{

  if(perm(sub_item_id,act_type)==false)
    return false  
  
  const admin_act_type_desc = admin_user_is_view_by_level(item_id,sub_item_id,act_type)
  //console.log(`admin_act_type_desc = ${admin_act_type_desc}`)
  if(admin_act_type_desc == "all"){
    return true
  }
  else{
    //console.log(`id_card = ${id_card} and emp_level = ${emp_level}`)
    //==== ตรวจสอบข้อมูลของ Employee โดยการ request ข้อมูลจาก db เพื่อนำกลับลงมาตรวจสอบร่วมกับข้อมูลของ admin user ====
    const isEXP = perm_is_exp(item_id,sub_item_id,act_type)==true && emp_is_expat(id_card) == true ? true : false
    //console.log(`perm_is_exp = ${perm_is_exp(item_id,sub_item_id,act_type)} and emp_is_expat = ${emp_is_expat(id_card)}`)
    if(emp_level == undefined || emp_level == null || emp_level == ''){
      const isActPerm = true
      //console.log(`isActPerm = ${isActPerm}`)
      return !isEXP && !isActPerm ? false : true
    }
    else{
      const isActPerm = emp_level && admin_act_type_desc.indexOf(emp_level)>-1 ? true : false
      //console.log(`isActPerm = ${isActPerm}`)
      return !isEXP && !isActPerm ? false : true
    }
    
  }
}

export var fetchEmpLevels = (token,empId) =>{
  return request
  .get(`/api/v1/organization/structure/employee/${Number(empId)}/level`)
  .set("Content-Type", "application/json")
  .set("Authorization", "JWT " + token)
}


export var checkAddEditAdminPermAndEmp=(item_id,sub_item_id,id_card,emp_level,main_tab_id=null)=>{

  if(perm(sub_item_id,2)==false)
    return false

  if(process.env.PROJECT == "TOA" || process.env.PROJECT == "CAPT" 
  || process.env.PROJECT == "TOA_UAT" || process.env.PROJECT == "CAPT_UAT"){
    if(perm(sub_item_id,2)){
      const x =  is_admin_emp_have_perm(item_id,sub_item_id,2,id_card,emp_level)
      return x
    }
    else{
      return false
    }
  }
  else{
    //return main_tab_id ? perm(main_tab_id,2) : false
    return true
  }
}

export var getRoleId = ()=>{
  if(perm_act_opt.length>0){
    return perm_act_opt[0].role_id
  }
  else{
    return 0
  }
}

//==== End for TOA ========